import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { Button } from '@components';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
    messageError,
    messageToast,
    objectRoles,
    typeError,
    styleSelectDefault,
    styleSelectError
} from '../../utils/define';
import {
    updateAccountAction,
    getByIdAccountAction
} from '../../store/reducers/account';
import { ROLE_API, POSITION_API, ACCOUNT_POSITION_API } from '@app/utils/apiUrl';
import {DeleteSingle, Get, Post} from '../../utils/httpProvider';
import { useQuery, useQueryClient } from 'react-query';
import { AsyncPaginate } from 'react-select-async-paginate';

const schema = yup.object().shape({
    firstName: yup.string().required(messageError.emptyMessage),
    lastName: yup.string().required(messageError.emptyMessage),
    email: yup
        .string()
        .email(messageError.emailMessage)
        .required(messageError.emptyMessage),
    roles: yup.array().min(1, messageError.emptyMessage),
    password: yup
        .string()
        .min(6, messageError.minLength6Message)
        .max(30, messageError.maxLength30Message),
    confirmPassword: yup
        .string()
        .oneOf([yup.ref('password'), null], messageError.likePassword)
        .when('password', {
            is: (value) => value && value.length > 0,
            then: yup.string().required(messageError.emptyMessage)
        })
});

const AccountEdit = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const queryClient = useQueryClient();
    const [idAccount, setIdAccount] = useState('');

    const itemAccount = useSelector((state) => state.account.itemAccount);
    // const roleArrayString =
    //     itemAccount && itemAccount.roles ? itemAccount.roles.split(', ') : [];
    // const roleObjectString = [];
    // if (roleArrayString && roleArrayString.length > 0) {
    //     roleArrayString.forEach((element) => {
    //         const filteredValue = objectRoles.find(
    //             (item) => item.value === element
    //         );
    //         roleObjectString.push(filteredValue);
    //     });
    // }

    useEffect(() => {
        const paramUrl = new URLSearchParams(location.search.substring(1));
        if (paramUrl.get('id') != null) {
            const id = paramUrl.get('id');
            setIdAccount(id);
            dispatch(getByIdAccountAction(id));
        }
    }, []);

    const handleUpdate = async (values, actions) => {
        const model = { ...values };
        const selectedPositionId = model.positionId || null;
        delete model.positionId;
        // const roleAccount =
        //     model.roles.length > 0 ? model.roles.map((x) => x.value) : [];
        // model.roles = roleAccount;
        // if (model.password === '' && model.confirmPassword === '') {
        //     delete model.password;
        //     delete model.confirmPassword;
        // }

        const modelUpdate = {
            data: model,
            id: idAccount
        };

        try {
            const result = await dispatch(updateAccountAction(modelUpdate));
            if (result.meta.requestStatus === 'rejected') {
                const payload = result.payload;
                if (payload && payload.errors) {
                    if (payload.type === typeError.Email) {
                        actions.setErrors({
                            email: payload.errors.content[0]
                        });
                    } else {
                        toast.error(payload.errors.content[0]);
                    }
                } else {
                    toast.error(payload?.message || payload?.Errors?.content?.[0] || 'Cập nhật tài khoản không thành công');
                }
            } else {
                // Dual write Position to WebApi
                if (selectedPositionId) {
                    try {
                        const positionResponse = await Post(ACCOUNT_POSITION_API.UPSERT, null, {
                            accountId: idAccount,
                            positionId: selectedPositionId
                        });
                        if (!positionResponse?.ok) {
                            throw new Error('Đồng bộ vị trí sang WebApi thất bại');
                        }
                        queryClient.invalidateQueries(['getAccountPosition', idAccount]);
                    } catch (posError) {
                        console.error('Error dual-writing position', posError);
                        toast.warn('Cập nhật tài khoản thành công nhưng chưa đồng bộ được vị trí sang WebApi.');
                    }
                } else {
                    try {
                        const positionResponse = await DeleteSingle(ACCOUNT_POSITION_API.DELETE_BY_ACCOUNT_ID, idAccount, null);
                        if (!positionResponse?.ok) {
                            throw new Error('Bỏ gán vị trí trên WebApi thất bại');
                        }
                        queryClient.invalidateQueries(['getAccountPosition', idAccount]);
                    } catch (posError) {
                        console.error('Error deleting position', posError);
                        toast.warn('Cập nhật tài khoản thành công nhưng chưa bỏ gán được vị trí trên WebApi.');
                    }
                }

                toast.success(messageToast.messageToastUpdateSuccess);
                history.goBack();
            }
        } catch (error) {
            toast.error(messageToast.messageToastTryCatch);
        }
    };

    const listRole = useQuery(['getAllRolesFromAuthServer'], () =>
        Get(ROLE_API.GET_PAGING, null, {
            PageIndex: 1,
            PageSize: 10000
        })
    );

    const lstRole =
        listRole &&
            listRole.data &&
            listRole.data.data &&
            listRole.data.data.length > 0
            ? listRole.data.data.map((x) => ({
                name: x.name,
                id: x.id
            }))
            : [];

    console.log('lstRole', lstRole);

    // const loadOptions = async (inputValue, loadedOptions, {page}) => {
    //     console.log('lstRole', lstRole);
    //     const filteredOptions = lstRole
    //         .filter((option) =>
    //             option.label.toLowerCase().includes(inputValue.toLowerCase())
    //         )
    //         .slice(0, 6);

    //     // Return all filtered options, no matter how many there are
    //     return {
    //         options: filteredOptions,
    //         hasMore: false,
    //         additional: {
    //             page: page + 1
    //         }
    //     };
    // };

    const loadOptions = async (inputValue, loadedOptions, { page }) => {
        const filtered = lstRole
            .filter((o) =>
                o.name.toLowerCase().includes(inputValue.toLowerCase())
            )
            .slice(0, 6);
        return {
            options: filtered,
            hasMore: false,
            additional: { page: page + 1 }
        };
    };

    const { data: positionsData } = useQuery(['getAllActivePositions'], async () => {
        const res = await Get(POSITION_API.GET_ALL_ACTIVE, null, null);
        return Array.isArray(res) ? res : (res?.data || []);
    });
    const positionOptions = (positionsData || []).map((pos) => ({
        value: pos.id,
        label: pos.name
    }));

    const {
        data: accountPosition,
        isFetching: isFetchingAccountPosition
    } = useQuery(
        ['getAccountPosition', idAccount],
        () => Get(ACCOUNT_POSITION_API.GET_BY_ACCOUNT_ID, idAccount, null),
        {
            enabled: !!idAccount,
            cacheTime: 0,
            refetchOnMount: 'always',
            refetchOnWindowFocus: false
        }
    );

    const accountPositionData = accountPosition?.data || accountPosition?.Data || accountPosition;
    const accountPositionId = accountPositionData?.positionId || accountPositionData?.PositionId || '';
    const fallbackPositionId = itemAccount?.accountAuthInfo?.positionId ||
        itemAccount?.AccountAuthInfo?.PositionId ||
        '';
    const selectedPositionId = accountPositionId || fallbackPositionId;

    return (
        <Card>
            <Card.Header as="h5">Sửa thông tin tài khoản</Card.Header>
            <Card.Body>
                {itemAccount == null ? (
                    <div>Tài khoản không tồn tại</div>
                ) : isFetchingAccountPosition ? (
                    <div>Đang tải thông tin vị trí...</div>
                ) : (
                    <Formik
                        enableReinitialize
                        validationSchema={schema}
                        onSubmit={(values, actions) =>
                            handleUpdate(values, actions)
                        }
                        initialValues={{
                            firstName: itemAccount ? itemAccount.accountAuthInfo?.firstName : '',
                            middleName: itemAccount ? itemAccount.accountAuthInfo?.middleName : '',
                            lastName: itemAccount ? itemAccount.accountAuthInfo?.lastName : '',
                            email: itemAccount ? itemAccount.accountAuthInfo?.email : '',
                            roles:
                                itemAccount
                                    ? itemAccount.roles
                                    : [],
                            phoneNumber: itemAccount
                                ? itemAccount.accountAuthInfo?.phoneNumber
                                : '',
                            pseudonym: itemAccount ? itemAccount.accountAuthInfo?.pseudonym : '',
                            password: '',
                            confirmPassword: '',
                            isActive: itemAccount ? itemAccount.isActive : true,
                            positionId: selectedPositionId
                        }}
                    >
                        {({
                            handleSubmit,
                            handleChange,
                            values,
                            errors,
                            setFieldValue
                        }) => (
                            <Form noValidate onSubmit={handleSubmit}>
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label className="col-sm-2 col-form-label">
                                        Họ *
                                    </Form.Label>
                                    <Col sm="10">
                                        <Form.Control
                                            type="text"
                                            placeholder="Họ"
                                            name="lastName"
                                            value={values.lastName}
                                            onChange={handleChange}
                                            isInvalid={!!errors.lastName}
                                        />

                                        <Form.Control.Feedback type="invalid">
                                            {errors.lastName}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label className="col-sm-2 col-form-label">
                                        Tên đệm
                                    </Form.Label>
                                    <Col sm="10">
                                        <Form.Control
                                            type="text"
                                            placeholder="Tên đệm"
                                            name="middleName"
                                            value={values.middleName}
                                            onChange={handleChange}
                                            isInvalid={!!errors.middleName}
                                        />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label className="col-sm-2 col-form-label">
                                        Tên *
                                    </Form.Label>
                                    <Col sm="10">
                                        <Form.Control
                                            type="text"
                                            placeholder="Tên"
                                            name="firstName"
                                            value={values.firstName}
                                            onChange={handleChange}
                                            isInvalid={!!errors.firstName}
                                        />

                                        <Form.Control.Feedback type="invalid">
                                            {errors.firstName}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label className="col-sm-2 col-form-label">
                                        Email *
                                    </Form.Label>
                                    <Col sm="10">
                                        <Form.Control
                                            type="text"
                                            placeholder="Email"
                                            name="email"
                                            value={values.email}
                                            onChange={handleChange}
                                            isInvalid={!!errors.email}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.email}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label className="col-sm-2 col-form-label">
                                        Số điện thoại
                                    </Form.Label>
                                    <Col sm="10">
                                        <Form.Control
                                            type="text"
                                            placeholder="Số điện thoại"
                                            name="phoneNumber"
                                            value={values.phoneNumber}
                                            onChange={handleChange}
                                        // isInvalid={!!errors.email}
                                        />
                                    </Col>
                                </Form.Group>
                                {/* <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Bút danh
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        type="text"
                                        placeholder="Bút danh"
                                        name="pseudonym"
                                        value={values.pseudonym}
                                        onChange={handleChange}
                                    />
                                </Col>
                            </Form.Group> */}
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label className="col-sm-2 col-form-label">
                                        Quyền được cho phép truy cập
                                    </Form.Label>
                                    <Col sm="10">
                                        <AsyncPaginate
                                            isMulti
                                            name="roles"
                                            placeholder="Chọn quyền được cho phép truy cập"
                                            value={values.roles}
                                            getOptionLabel={(opt) => opt.name}
                                            getOptionValue={(opt) => opt.id}
                                            loadOptions={loadOptions}
                                            styles={
                                                errors.roles
                                                    ? styleSelectError
                                                    : styleSelectDefault
                                            }
                                            onChange={(options) => {
                                                setFieldValue(
                                                    'roles',
                                                    options
                                                );
                                            }}
                                            additional={{
                                                page: 1
                                            }}
                                        />
                                        <div
                                            className="invalid-feedback"
                                            style={{ display: 'block' }}
                                        >
                                            {errors.roles}
                                        </div>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label className="col-sm-2 col-form-label">
                                        Vị trí
                                    </Form.Label>
                                    <Col sm="10">
                                        <Select
                                            name="positionId"
                                            placeholder="Chọn vị trí"
                                            isClearable
                                            isSearchable
                                            options={positionOptions}
                                            value={positionOptions.find((opt) => String(opt.value) === String(values.positionId)) || null}
                                            onChange={(option) => {
                                                setFieldValue('positionId', option ? option.value : '');
                                            }}
                                            noOptionsMessage={() => 'Không tìm thấy vị trí'}
                                        />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label className="col-sm-2 col-form-label">
                                        Mật khẩu *
                                    </Form.Label>
                                    <Col sm="10">
                                        <Form.Control
                                            type="password"
                                            placeholder="Mật khẩu"
                                            name="password"
                                            value={values.password}
                                            onChange={handleChange}
                                            isInvalid={!!errors.password}
                                        />

                                        <Form.Control.Feedback type="invalid">
                                            {errors.password}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label className="col-sm-2 col-form-label">
                                        Xác nhận mật khẩu *
                                    </Form.Label>
                                    <Col sm="10">
                                        <Form.Control
                                            type="password"
                                            placeholder="Xác nhận mật khẩu"
                                            name="confirmPassword"
                                            value={values.confirmPassword}
                                            onChange={handleChange}
                                            isInvalid={!!errors.confirmPassword}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.confirmPassword}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label className="col-sm-2 col-form-label">
                                        Trạng thái kích hoạt
                                    </Form.Label>
                                    <Col sm="10" className="icheck-primary">
                                        <Form.Control
                                            id="checkboxPrimary1"
                                            type="checkbox"
                                            placeholder="Trạng thái"
                                            name="isActive"
                                            checked={values.isActive}
                                            onClick={handleChange}
                                        />
                                        <Form.Label htmlFor="checkboxPrimary1">
                                            {' '}
                                        </Form.Label>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3">
                                    <Col md={{ span: 10, offset: 2 }}>
                                        <ButtonGroup className="mb-2">
                                            <Button
                                                type="submit"
                                                theme="primary"
                                            >
                                                Cập nhật
                                            </Button>
                                            &nbsp;&nbsp;&nbsp;
                                            <Button
                                                onClick={() => history.goBack()}
                                                theme="secondary"
                                            >
                                                Hủy
                                            </Button>
                                        </ButtonGroup>
                                    </Col>
                                </Form.Group>
                            </Form>
                        )}
                    </Formik>
                )}
            </Card.Body>
        </Card>
    );
};

export default AccountEdit;
